import persianToEnglishNumbers from "./farsiToEnglishNumber";

export function normalizePhoneNumber(input) {
  const englishNumber = persianToEnglishNumbers(input)
  // Remove all non-digit characters
  let digits = englishNumber?.replace(/\D/g, '');

  // Remove leading zeros
  digits = digits?.replace(/^0+/, '');

  // Remove leading country code if exists (e.g., 98 or 0098)
  if (digits?.startsWith('98')) {
    digits = digits?.substring(2);
  }

  // Now ensure it starts with a 9 and is 10 digits long
  if (digits?.length === 10 && digits?.startsWith('9')) {
    return '0' + digits;
  }

  // If it's already in the correct format
  if (digits?.length === 11 && digits?.startsWith('09')) {
    return digits;
  }

  // Invalid format
  return null;
}

  